<style lang="scss" scoped>
.bindPhon {
  .loginBox {
    width: 888px;
    height: 426px;
    background: #ffffff;
    border-radius: 2px;
    margin: 0 auto;
    display: flex;
    .custom_button {
      width: 290px;

      ::v-deep .el-input__inner {
        border: none !important;
        border-bottom: 1px solid #eeeeee !important;
        padding: 5px;
      }
    }
    .custom_button_sm {
      width: 190px;
    }
    .left {
      position: relative;
      .backImg {
        width: 380px;
      }
      .top {
        width: 136px;
        height: 40px;
        position: absolute;
        top: 128px;
        left: 50%;
        transform: translateX(-50%);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title {
        position: absolute;
        top: 229px;
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        // line-height: 37px;
        letter-spacing: 3px;
        width: 100%;
        text-align: center;
      }
    }
    .right {
      width: 100%;
      text-align: center;
      .title {
        // width: 100%;
        // text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #555555;
        // line-height: 28px;
        letter-spacing: 1px;
        margin: 53px 0 40px 0;
      }
      .form {
        margin-left: 108px;
        text-align: left;
        margin-bottom: 40px;

        &_label {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #888888;
          margin-bottom: 10px;
        }

        .form-phone {
          margin-bottom: 28px;
        }
      }
      .btn {
        margin-right: 0;
        border-radius: 2px;
        border: 1px solid #2083e0;
        background-color: #fff;
        color: #2083e0;
      }
    }
    .loginBtn {
      width: 200px;
      height: 40px;
      background: #2083e0;
      border-radius: 2px;
    }
  }
  .footer {
    margin-top: 60px;
    .btn {
      width: 300px;
    }
    .register {
      margin-top: 16px;
    }
  }
}
.input__inner {
  border: none !important;
}
</style>
<template>
  <div class="bindPhon">
    <div
      v-if="false"
      class="loginBox"
      style="display: flex"
    >
      <div class="left">
        <img
          class="backImg"
          :src="require('@/assets/img/qwLogin/loginbk.png')"
          alt=""
        >
        <div class="top">
          <img
            class="backImg"
            :src="require('@/assets/img/qwLogin/index3logo.png')"
            alt=""
          >
        </div>
        <div class="title">
          营销中心
        </div>
      </div>
      <div class="right">
        <div class="title">
          免费试用
        </div>
        <div class="form">
          <div class="form-phone">
            <div class="form_label">
              手机号码
            </div>
            <el-input
              v-model="form.phoneNumber"
              placeholder="请输入手机号码"
              class="input-m m-r-6 input__inner custom_button"
              clearable
            />
          </div>
          <div class="form-code">
            <div class="form_label">
              验证码
            </div>
            <div style="display: flex; width: 290px">
              <el-input
                v-model="form.code"
                placeholder="请输入验证码"
                class="input-m m-r-6 input__inner custom_button custom_button_sm"
                clearable
              />
              <el-button
                type="primary"
                plain
                class="btn"
                @click="getPhoneCode"
              >
                {{ codeTime == 0 ? '获取验证码' : `${codeTime}s后重新发送` }}
              </el-button>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          class="loginBtn"
          @click="bindPhone"
        >
          立即使用
        </el-button>
      </div>
    </div>
    <!-- 权鉴 -->
    <div v-if="!!logType">
      <Dialog
        :title="logData.title[logType]"
        :desc="logData.desc[logType]"
      >
        <div
          slot="footer"
          class="footer"
        >
          <!-- 超管不存在 -->
          <div v-if="logType == '42301'">
            <el-button
              type="primary"
              class="btn"
              @click="$router.push('/')"
            >
              重新登录
            </el-button>
            <div class="register">
              还没有商派账号? <el-button
                type="text"
                @click="goOfficial"
              >
                点击注册
              </el-button>
            </div>
          </div>
          <!-- 子管理员无权限 -->
          <div v-else>
            <el-button
              type="primary"
              class="btn"
              @click="$router.push('/login')"
            >
              重新登录
            </el-button>
          </div>
        </div>
      </Dialog>
    </div>
    <!-- 绑定手机 -->
    <div v-if="showBindPhone">
      <BindPhoneDialog />
    </div>
  </div>
</template>

<script>
import Dialog from './comps/bindAccount/Dialog.vue'
import BindPhoneDialog from './comps/bindAccount/bindPhoneDialog.vue'
import { getOpenworkwechat } from '@/api/qwAuth'
import bindPhoneMixin from './mixins/bindPhone.js'
export default {
  components: {
    Dialog,
    BindPhoneDialog
  },
  mixins: [bindPhoneMixin],
  data () {
    const logData = {
      title: {
        '42301': '登录失败,企业未授权', //4.2 超级管理员不存在（企业未授权）: 42301
        '42302': '登录失败，该账号无权限', //8.1 子管理员无权限:    目前判断不了(42302)
        '40101': '登录失败，该账号不存在', // 8.2 子管理员不存在:  40101
        '42104': '登录失败，该账号无权限', // 8.3 子管理员初次进入销售中心: 42104
        '42201': '未找到auth_code',
        '50000': '绑定异常'
      },
      desc: {
        '42301':
          '您正在登录的企业未授权给商派，请重新选择企业或者注册商派营销中心，如有疑问请联系客服',
        '42302':
          '您正在登录的账号没有商派营销中心的使用权限，请重新选择账号或联系管理员添加权限，如有疑问请联系客服',
        '40101':
          '您正在登录的账号没有商派营销中心的使用权限，请重新选择账号或联系管理员在企业微信后台修改应用可见范围，在营销中心后台同步账号并设置角色后再次尝试登录，如有疑问请联系客服',
        '42104':
          '您正在登录的账号没有商派销售中心的使用权限，请联系管理员添加权限，如有疑问请联系客服',
        '50000': '该企业微信已与其他商派账号绑定'
      }
    }
    return {
      codeTime: 0,
      form: {
        phoneNumber: '',
        code: null
      },
      //授权拿到的企业信息
      showBindPhone: false,
      logType: null,
      logData
    }
  },
  watch: {},
  mounted () {
    this.toPreLogin()
    // this.getQWConfig()
  },
  methods: {
    //查询当前企业是否配置过企微信息
    getQWConfig () {
      getOpenworkwechat().then((res) => {
        console.log('查询当前企业是否配置过企微信息', res)
        this.endLoading()
        if (res.is_complete) this.$router.push({ path: '/', replace: true })
        else this.$router.push({ path: '/qwAuth/bindCS' })
      })
    },
    //前往官网
    goOfficial () {
      window.open('https://www.shopex.cn/solution/wechat_work')
    }
  }
}
</script>
